/**
 * Gate Workshop openers (Color yours + card brush) on SVG availability.
 * Probes data-zellij-svg-probe once per URL; caches in memory + sessionStorage.
 * Missing or failed checks hide the control (fail closed).
 */
(function () {
  'use strict';

  if (window.ZellijLabSvgGate) return;

  var CACHE_KEY = 'zellij_lab_svg_probe_v1';
  var memory = Object.create(null);
  var inflight = Object.create(null);

  function readSessionCache() {
    try {
      var raw = sessionStorage.getItem(CACHE_KEY);
      if (!raw) return Object.create(null);
      var parsed = JSON.parse(raw);
      return parsed && typeof parsed === 'object' ? parsed : Object.create(null);
    } catch (err) {
      return Object.create(null);
    }
  }

  function writeSessionCache(url, ok) {
    try {
      var store = readSessionCache();
      store[url] = ok === true;
      sessionStorage.setItem(CACHE_KEY, JSON.stringify(store));
    } catch (err) {
      /* private mode / quota: memory cache still applies */
    }
  }

  function probePatternSvg(url) {
    if (!url) return Promise.resolve(false);
    if (Object.prototype.hasOwnProperty.call(memory, url)) {
      return Promise.resolve(memory[url]);
    }
    var session = readSessionCache();
    if (Object.prototype.hasOwnProperty.call(session, url)) {
      memory[url] = session[url] === true;
      return Promise.resolve(memory[url]);
    }
    if (inflight[url]) return inflight[url];

    function attempt(n) {
      return fetch(url, { method: 'GET', mode: 'cors', cache: 'force-cache' })
        .then(function (res) {
          return !!(res && res.ok);
        })
        .catch(function () {
          if (n + 1 >= 2) return false;
          return new Promise(function (resolve) {
            setTimeout(function () {
              resolve(attempt(n + 1));
            }, 400);
          });
        });
    }

    inflight[url] = attempt(0)
      .then(function (ok) {
        var result = ok === true;
        memory[url] = result;
        writeSessionCache(url, result);
        return result;
      })
      .catch(function () {
        memory[url] = false;
        writeSessionCache(url, false);
        return false;
      })
      .then(function (result) {
        delete inflight[url];
        return result;
      });

    return inflight[url];
  }

  function hideControl(el) {
    if (!el) return;
    el.hidden = true;
    el.setAttribute('data-zellij-svg-unavailable', '1');
    el.removeAttribute('data-zellij-svg-pending');
    if (el.classList.contains('zellij-color-yours-btn')) {
      el.removeAttribute('aria-controls');
    }
    try {
      if (el.parentNode) el.parentNode.removeChild(el);
    } catch (err) {
      /* leave hidden */
    }
  }

  function revealControl(el) {
    if (!el) return;
    el.hidden = false;
    el.removeAttribute('data-zellij-svg-pending');
    if (
      el.classList.contains('zellij-color-yours-btn') &&
      !el.getAttribute('aria-controls')
    ) {
      el.setAttribute('aria-controls', 'zellij-design-lab-overlay');
    }
  }

  function gateAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var nodes = scope.querySelectorAll(
      '[data-zellij-svg-probe]:not([data-zellij-svg-gated])'
    );
    if (!nodes.length) return;
    Array.prototype.forEach.call(nodes, function (el) {
      el.setAttribute('data-zellij-svg-gated', '1');
      el.setAttribute('data-zellij-svg-pending', '1');
      el.hidden = true;
      var url = el.getAttribute('data-zellij-svg-probe') || '';
      probePatternSvg(url).then(function (ok) {
        if (ok === true) {
          revealControl(el);
          return;
        }
        hideControl(el);
      });
    });
  }

  function blockUntilGated(event) {
    var el =
      event.target &&
      event.target.closest &&
      event.target.closest('[data-zellij-svg-probe], .card-workshop-brush, .zellij-color-yours-btn');
    if (!el) return;
    if (el.getAttribute('data-zellij-svg-unavailable') === '1') {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    if (el.hidden || el.getAttribute('data-zellij-svg-pending') === '1') {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  document.addEventListener('click', blockUntilGated, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      gateAll();
    });
  } else {
    gateAll();
  }

  window.ZellijLabSvgGate = {
    gateAll: gateAll,
    probe: probePatternSvg,
    hideControl: hideControl
  };
})();
